import {TwoFAFormModel} from "../../models/forms/2FAFormModel";
import {handleHTTPError} from "../../components/ErrorFactory";
import {ApiDataHelper} from "../../data/ApiDataHelper";
import {HTTPError} from "../../models/errors/HTTPError";
import {delay} from "../delay";
import {AuthenticateModelReturn} from "../../models/authentication/AuthenticateModel";

export async function twoFAForm(body: TwoFAFormModel) {
    // Input validation

    // Check that the form input is not null
    if (
        body.inputs.code.current == null
    ) {
        body.setBanner(handleHTTPError(406, "The TOTP code input cannot be empty."));
        return;
    }
    // Check that the TOTP code is 6 characters long
    else if (body.inputs.code.current.value.length !== 6) {
        body.setBanner(handleHTTPError(406, "The TOTP code must be 6 digits long."));
        return
    }
    // Check that the TOTP code can be parsed as an integer
    else if (isNaN(parseInt(body.inputs.code.current.value))) {
        body.setBanner(handleHTTPError(406, "The TOTP code must be a number."));
        return;
    }

    // Create API interface object
    const api = new ApiDataHelper(body.memory);

    // Authenticate the user
    try {
        const token = await api.Execute<AuthenticateModelReturn>('/auth/2fa/authenticate', {
            body: JSON.stringify({
                code: body.inputs.code.current.value
            }),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            credentials: 'include' as RequestCredentials,
            method: 'POST'
        }, false, 0);

        // Set accessToken in local memory
        if (token !== undefined) {
            body.memory.memory[0].AccessToken = token.accessToken;
            body.memory.memory[1](body.memory.memory[0]);
        }

        // Set the banner to say the user is authenticated
        body.setBanner(handleHTTPError(200, "You're now authenticated with 2FA! Redirecting..."));
        await delay(3000);

        // Check if the user has a redirect URL
        if (body.memory.memory[0].URLBefore2FA !== undefined) {
            const url = body.memory.memory[0].URLBefore2FA;

            // Clear the URLBefore2FA memory
            body.memory.memory[0].URLBefore2FA = undefined;
            body.memory.memory[1](body.memory.memory[0]);

            body.memory.memory[0].Router(url);
        }
        // If not, redirect to the dashboard
        else {
            body.memory.memory[0].Router('/account/dashboard');
        }
    }
    catch(e) {
        // If the error is a HTTP related exception
        if (e instanceof HTTPError) {
            body.setBanner(handleHTTPError(e.code, e.message))
        }
        else {
            body.setBanner(handleHTTPError(999, ""))
        }
    }
}